import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'region';

const RegionService = {
  getList(countryIds) {
    const countryGetField =  ApiUtil.buildArrayToQueryString('countryId', countryIds);

    return Http.get(`/${RESOURCE_NAME}?${countryGetField}`);
  },

  getListByStudent(countryIds) {
    const countryGetField =  ApiUtil.buildArrayToQueryString('countryId', countryIds);

    return Http.get(`/${RESOURCE_NAME}/list?${countryGetField}`);
  },
};

export default RegionService;
